import React from 'react'

export default function TopIssuesWidget(props: any) {
  const { title, subTitle, handleClick } = props;

  return (
    <div className="widget">
      {/* header */}
      <div className="d-flex align-items-center justify-content-between">
        <h3 className="widget-title">{title}</h3>

        <button className="btn btn-flat text-white flex-center">
          View Report
          <i className="icon-arrow-right text-5c ml-2"></i>
        </button>
      </div>
      {/* Header */}
      <h6 className="text-gray-400 fw-300">
        <small className="text-gray-500 ml-1">{subTitle}</small>
      </h6>

      <ul className="time-line">
        <li onClick={handleClick}>
          <h4 className="text-gray-50">
            Failure of supply chain due to geopolitical issues
          </h4>
          <span className="d-flex text-gray-400 align-items-center">
            <span className="dot bg-danger mr-1"></span>
            <small>High increasing</small>
            <span className="d-inline-flex mh-2 text-3c">|</span>
            <span>
              <i className="icon-map-pin mr-1"></i> USA, NY
            </span>
          </span>
        </li>

        <li>
          <h4 className="text-gray-50">
            Business disruption due to issues such as equipment failure or
            system malfunctions
          </h4>
          <span className="d-flex text-gray-400 align-items-center">
            <span className="dot bg-success mr-1"></span>
            <small>Very low increasing</small>
            <span className="d-inline-flex mh-2 text-3c">|</span>
            <span>
              <i className="icon-map-pin mr-1"></i> Financial
            </span>
          </span>
        </li>
      </ul>
    </div>
  );
}
